<template>
    <span v-if="!dateHasCome">{{formatted}}</span>
</template>

<script>

    import moment from 'moment'
    import 'moment-duration-format'

    export default {
        name: 'attempt-guard-countdown',
        mounted() {
            this.intervalId = window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000)

                if (this.dateHasCome) {
                    clearInterval(this.intervalId)
                    this.$emit('release')
                }
            }, 1000)
        },
        props: {
            nextAttemptAfter: {
                Type: String
            }
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000)
            }
        },
        destroyed() {
            if (this.intervalId) {
                window.clearInterval(this.intervalId)
            }
        },
        computed: {
            formatted() {
                const diff = moment(this.nextAttemptAfter).subtract(this.now, 'seconds')

                return moment.duration(diff, 'milliseconds').format('hh:mm:ss', {trim: 'left'})
            },
            dateHasCome() {
                let diff = moment(this.nextAttemptAfter).subtract(this.now, 'seconds')

                return diff < 0
            }
        }
    }
</script>

<style scoped>

</style>
